<template>
    <div :class="tamanho">
        <div class="mainflip">
            <div class="frontside">
                <div class="card" data-toggle="modal" :data-target="(ips && ips.length && id) ? '#' + id : null" :style="'background-color: '+ isOnlineBack +'; border: ' + isOnline + ' solid 4px;  padding: 5px; cursor: pointer'">
                    <div class="card-body text-center">
                        <div style="padding: 3px">
                            <img v-if="image" :src="image" alt="card image"> <!--style="width: 5vw">-->
                            <i v-if="icon" :class="'fa fa-' + icon" style="color: white; font-size: 30px" aria-hidden="true"/>
                        </div>
                        <h3 class="card-title" :style="'color: black !important;'">
                            <b>{{ title | truncate(10) | uppercase }}</b>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="ips && ips.length && id" class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document" style="width: 90vw">
                <div class="modal-content">

                    <div class="modal-header">
                        <div class="col-sm-6" >
                            <h2 class="modal-title" >{{ title }}</h2>
                        </div>
                        <div class="col-sm-6" >
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="modal-body" style="height: calc(100vh - 150px)">
                        <div class="container-fluid">
                            <div class="row" style="margin-top: 50px">
                                <div class="col-sm-12" >
                                    <div class="row">
                                        <card :key="index" v-for="(r, index) in ips" :image="image" :title="r.nome" :ip="r.ip" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Card",
    props: {
        title: {
            default: "nome"
        },
        ip: {
            default: null
        },
        id: {
            default: null
        },
        tamanho: {
            default: "col-md-2"
        },
        ips: {
            default: null
        },
        icon: {
            default: null
        },
        image: {
            default: null
        }
    },
    data() {
        return {
            online: false,
            interval: null
        };
    },
    computed: {
        isOnline: function() {
            return this.online ? "#2E7D32" : "#E53935";
        },
        isOnlineBack: function() {
            return this.online ? "#E8F5E9" : "#FBE9E7";
        }
    },
    sockets: {
        // Fired when the server sends something on the "messageChannel" channel.
        pingStatus(data) {
            // console.log(this.ips, data.ips);
            if (
                this.ip === data.ip ||
                JSON.stringify(this.ips) === JSON.stringify(data.ips)
            ) {
                this.online = data.data;
            }
        }
    },
    mounted() {
        this.interval = setInterval(() => this.send(), 15000);
        this.send();
    },
    methods: {
        send() {
            if (this.ip) {
                this.$socket.emit("pingIN", { ip: this.ip });
            }
            if (this.ips && this.ips.length) {
                this.$socket.emit("pingIN", { ips: this.ips });
            }
        }
    }
};
</script>

<style scoped>
section {
    padding: 60px 0;
}

.card {
    border: none;
    border-radius: 5px;
    border-top-right-radius: 20px;
    background: #73ad21;
}

.image-flip:hover .frontside,
.image-flip.hover .frontside {
    -webkit-transform: rotateY(180deg);
    -moz-transform: rotateY(180deg);
    -o-transform: rotateY(180deg);
    transform: rotateY(180deg);
}

.mainflip {
    -webkit-transition: 1s;
    -webkit-transform-style: preserve-3d;
    transition: 1s;
    position: relative;
}

.frontside {
    position: relative;
    -webkit-transform: rotateY(0deg);
    -ms-transform: rotateY(0deg);
    z-index: 2;
    margin-bottom: 30px;
}

.frontside .card,
.backside .card {
    min-height: 112px;
}

.backside .card a {
    font-size: 18px;
    color: #007b5e !important;
}

.frontside .card .card-title,
.backside .card .card-title {
    color: #ffffff !important;
}

.frontside .card .card-body img {
    height: 50px;
    border-radius: 40%;
}
</style>
